import React from 'react';
import pt from 'prop-types';

import styles from './OffsetAnchor.pcss';

// Offset tag with ID so scrolling for
// internal anchors has a bit of padding
// https://stackoverflow.com/a/49968820
const OffsetAnchor = ({id}) => <div className={styles.el} id={id} />;

OffsetAnchor.propTypes = {
    id: pt.string.isRequired
};

export default OffsetAnchor;
